/**
 * Safely copies text to the clipboard, returning a boolean instead of
 * throwing. `navigator.clipboard.writeText` can reject (or `navigator.clipboard`
 * can be `undefined`) in non-secure contexts, embedded iframes, or when the
 * Clipboard API is blocked by browser permissions. Without this guard those
 * failures surface as unhandled exceptions from click handlers.
 *
 * Callers that need to react to success/failure should check the return value.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (!navigator?.clipboard?.writeText) {
      console.warn('Clipboard API unavailable', {
        userAgent: navigator?.userAgent,
        secureContext: window.isSecureContext,
      });
      return false;
    }
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Clipboard write failed', {
      error: error instanceof Error ? error.message : String(error),
      userAgent: navigator?.userAgent,
    });
    return false;
  }
}
